import { useTheme } from 'styled-components';

export const AlertIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.7"
        d="M14.4 20.8H17.6V24H14.4V20.8ZM14.4 8H17.6V17.6H14.4V8ZM15.984 0C7.152 0 0 7.168 0 16C0 24.832 7.152 32 15.984 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 15.984 0ZM16 28.8C8.928 28.8 3.2 23.072 3.2 16C3.2 8.928 8.928 3.2 16 3.2C23.072 3.2 28.8 8.928 28.8 16C28.8 23.072 23.072 28.8 16 28.8Z"
        fill={theme.secondary.softBlue1}
      />
    </svg>
  );
};
